export const commonColor = {
  WARN: '#FF9900', // yellow
  FAIL: '#E02020', // red
  WHITE: '#FFFFFF', // white
  NORMAL: '#19BE6B', // green
  BLUE: '#2B85E4', // blue
  PINK: '#F7C0BA', // pink
}
